import {provideRouter, withComponentInputBinding, withRouterConfig, withViewTransitions} from '@angular/router';
import {provideAnimations} from '@angular/platform-browser/animations';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  importProvidersFrom,
  LOCALE_ID,
  Provider
} from '@angular/core';
import {routes} from './app.routes';
import {HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi} from '@angular/common/http';
import {SalesBillingModule} from './sales-billing/sales-billing.module';
import {QrCodeModule} from './qr-code/qr-code.module';
import {GuideModule} from './guide/guide.module';
import {ToastModule} from 'primeng/toast';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {PurchasingModule} from './purchasing/purchasing.module';
import {OutsourcingModule} from './outsourcing/outsourcing.module';
import {ProcurementModule} from './procurement/procurement.module';
import {StatisticsModule} from './statistics/statistics.module';
import {DecimalPipe} from '@angular/common';
import {MoneyFormatPipe} from '@shared/pipes/money-format.pipe';
import {AuthInterceptor} from './auth/auth.interceptor';
import {ErrorInterceptor} from '@shared/interceptors/error-interceptor';
import {TIME_ZONE} from '@shared/services/time-zone.service';
import {MessageService} from 'primeng/api';
import {provideEnvironmentNgxMask} from 'ngx-mask';
import {initializePrimeNgConfig} from "../config/primeng.initializer";
import {AppLocaleInitializerService} from "@shared/services/app-locale-initializer.service";
import {initializeAppLocale} from "../config/locale/locale.initializer";
import {CLIENT_CONFIG} from '../config/client-config.token';
import {createClientConfig} from '../config/config.factory';
import {BufferedMessageService} from '@shared/services/buffered-message.service';
import { mainHttpInterceptor } from '@shared/interceptors/main-http.interceptor';
import { MatDialog } from '@angular/material/dialog';
import { CustomMatDialog } from '@shared/services/custom-mat-dialog.service';

const INTERCEPTOR_PROVIDER: Provider = {
  provide: HTTP_INTERCEPTORS,
  useClass: AuthInterceptor,
  multi: true,
};

const INTERCEPTORS_ERROR: Provider = {
  provide: HTTP_INTERCEPTORS,
  useClass: ErrorInterceptor,
  multi: true,
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi(),
      withInterceptors([mainHttpInterceptor]),
    ),
    provideRouter(routes,
      withRouterConfig({}),
      withComponentInputBinding(),
      withViewTransitions(),
    ),
    provideEnvironmentNgxMask(),
    importProvidersFrom(
      SalesBillingModule,
      QrCodeModule,
      GuideModule,
      ToastModule,
      PdfViewerModule,
      PurchasingModule,
      OutsourcingModule,
      ProcurementModule,
      StatisticsModule,
    ),
    MessageService,
    DecimalPipe,
    MoneyFormatPipe,
    INTERCEPTOR_PROVIDER,
    INTERCEPTORS_ERROR,
    {
      provide: TIME_ZONE,
      useValue: '+0'
    },
    {
      provide: CLIENT_CONFIG,
      useFactory: createClientConfig,
      deps: [BufferedMessageService]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializePrimeNgConfig,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppLocale,
      deps: [AppLocaleInitializerService],
      multi: true
    },
    {
      provide: LOCALE_ID,
      useFactory: (localeService: AppLocaleInitializerService) => localeService.locale,
      deps: [AppLocaleInitializerService]
    },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useFactory: (localeService: AppLocaleInitializerService) => localeService.currencyCode,
      deps: [AppLocaleInitializerService]
    },
    { provide: MatDialog, useClass: CustomMatDialog },
  ]
};
